import { CustomRoleDto, CustomRolesApi } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'custom-roles';

type UseGetCustomRoles = (
  options: Omit<
    UseQueryOptions<CustomRoleDto[], ErrorResponse, CustomRoleDto[], string[]>,
    'queryKey' | 'queryFn'
  >,
) => UseQueryResult<CustomRoleDto[]>;

export const useGetCustomRoles: UseGetCustomRoles = (options) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const customRolesApi = new CustomRolesApi(getApiConfiguration());
  return useQuery(
    [QUERY_KEY],
    async () => customRolesApi.getCustomRoles(tenantId).then((res) => res.data),
    options,
  );
};
